"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateDegradedStrCopyComponentParameters = void 0;
exports.CreateDegradedStrCopyComponentParameters = [
    {
        id: 'source',
        label: 'Source String',
        description: 'Microtask input string to optionally degrade by removing random words',
        type: 'string',
        paramType: 'STRING',
        required: true,
    },
    {
        id: 'percentage',
        label: 'Degradation Probability',
        description: 'Percent chance (0-100) that random words are removed from the source string',
        type: 'float',
        paramType: 'FLOAT',
        min: 0,
        max: 100,
        required: true,
    },
    {
        id: 'word_count',
        label: 'Words to Remove',
        description: 'Number of random words to remove when degradation happens. Defaults to 1.',
        type: 'int',
        paramType: 'INT',
        min: 1,
        required: false,
    },
    {
        id: 'copy',
        label: 'Original String Copy',
        description: 'Output key where the original source string is stored when degradation happens',
        type: 'output',
        paramType: 'STRING',
        required: true,
    },
    {
        id: 'flag',
        label: 'Degradation Flag',
        description: 'Output boolean that is true when the source string was modified',
        type: 'output',
        paramType: 'BOOLEAN',
        required: true,
    },
];
//# sourceMappingURL=CreateDegradedStrCopy.js.map